import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { AuthService } from 'src/app/services/auth/auth.service';
import { AngularFireAuth } from "@angular/fire/compat/auth";

export interface PaymentMean {
    _id: number;
    N_PAYMENT_MEAN: string;
    MONEY: number;
    CURRENCY: string | null;
    CONVERSION: number;
    IMAGE: number;
}

interface AppUser {
    uid: string;
    email: string;
    displayName: string | null;
    phoneNumber: string | null;
    photoURL: string | null;
    providerId: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private af: AngularFireAuth,

    ) { }

    urlBase = environment.apiUrl; // Stocke l'url.
    user: AppUser | null = null; // Stocke les informations de l'utilisateur connecté (Firebase). 

    getClient() {
        this.authService.getUser.subscribe((user: AppUser) => {
            if (user) {
                // Compte client final
                this.user = user;
            }
        });
    } // Methode pour récupérer le client connecté (facultatif n'est la que pour des eventuels cartes de fidelites, etc...)

    async getIdToken(): Promise<string> {
        const user = await this.af.currentUser;
        return user?.getIdToken(false) ?? "invalid_token";
    } // Auth token Firebase

    async getPaymentMean(id: number): Promise<PaymentMean | null> {
        const token = await this.getIdToken();
        const res = await this.http.get<{ code: number, list: PaymentMean[] }>(
            `${this.urlBase}payment-mean/${id}`,
            { headers: { Authorization: token } }
        ).toPromise();

        return res?.list?.[0] ?? null;
    }

}
